module.exports = __webpack_public_path__ + "media/images/close-icon-638a71ad.svg";